module.exports = __webpack_public_path__ + "static/media/default-company.08b20855.jpg";